import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (lenis) return lenis;
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);
  return lenis;
}

export function scrollToSection(selector, presetInquiryType) {
  if (presetInquiryType) {
    window.dispatchEvent(
      new CustomEvent("gentec:preset-inquiry", { detail: presetInquiryType })
    );
  }
  if (lenis) {
    lenis.scrollTo(selector, { offset: -72, duration: 1.4 });
  } else {
    document
      .querySelector(selector)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export function scrollToTop() {
  if (lenis) {
    lenis.scrollTo(0, { duration: 1.2 });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
}
